import { useCallback } from 'react';
import { CLIP_UPDATE_TYPE } from '../../clipUpdateDataUtils/constants';
import { updateClipData } from '../../clipUpdateDataUtils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

/**
 * Hook that provides functionality to delete a scene and merge adjacent scenes if needed.
 */
export const useDeleteScene = () => {
  const { clipId } = useClipsContext();

  /**
   * Deletes a scene and merges adjacent scenes if needed.
   *
   * @param sceneId - The ID of the scene to delete
   * @param compositeId - The ID of the composite segment to delete the scene from
   */
  const deleteScene = useCallback(
    (sceneId: string, compositeId: string) => {
      updateClipData({
        clipId,
        actionType: CLIP_UPDATE_TYPE.REMOVE_COMPOSITE_SCENE,
        sceneId,
        compositeId
      });
    },
    [clipId]
  );

  return { deleteScene };
};
